export default "__VITE_ASSET__pO7PzC1P__"